import { useEffect } from "react";
import HeaderWeeklyReport from "../../../../Components/ComponentsIndustry/HeaderWeeklyReport";
import Loading from "../../../../Components/Loading";
import { useReportWeeklyIndustry } from "../../../../providers/ReportWeeklyIndustry";
import { useUser } from "../../../../providers/UserContext";

import {
  Container,
  SizeContainer,
  RoundContainer,
  H2RoundContainer,
  ParagraphRoundContainer,
  MainRoundContainer,
} from "./style";

const WeeklyReportPurchase = () => {
  const { industry, jogo } = useUser()
  const { reportWeeklyIndustry, loading, fetchReportWeeklyIndustry, setReportWeeklyIndustry } = useReportWeeklyIndustry()

  useEffect(() => {
    setReportWeeklyIndustry({
      purchases: [],
      pcp: [],
      productions: [],
      salesInProgress: [],
      salesDone: []
    })
    if (!industry || !jogo) return
    fetchReportWeeklyIndustry()
  }, [industry, jogo])

  return (
    <Container>
      <SizeContainer>
        <HeaderWeeklyReport selected={["", "selection", "", ""]} />
        {loading ? (
          <RoundContainer>
            <Loading />
          </RoundContainer>

        ) : reportWeeklyIndustry?.purchases.length === 0 ? (
          <RoundContainer style={{ justifyContent: 'center' }}>
            <p style={{ fontSize: 20, fontWeight: 'bold' }}>Nenhuma compra realizada.</p>
          </RoundContainer>
        ) : null
        }
        {reportWeeklyIndustry?.purchases?.map((purchase, index) => {
          return (
            <RoundContainer key={index}>
              <H2RoundContainer>
                RODADA {purchase[0]?.rodada?.numero}
                <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
              </H2RoundContainer>
              <ParagraphRoundContainer>
                Compra de insumos
                <img src="./images/purchase_button.svg" alt="purchase_button" />
              </ParagraphRoundContainer>
              <MainRoundContainer>
                {purchase?.map((item, index) => {

                  let imageURL = null
                  if (item.insumo.nome === "Frango P") {
                    imageURL = "./images/chicken_p.svg"
                  } else if (item.insumo.nome === "Caixa (Papelão)") {
                    imageURL = "./images/box.svg"
                  } else if (item.insumo.nome === "Pernil Suíno") {
                    imageURL = "./images/pig.svg"
                  }

                  return (
                    <div key={index}>
                      <img src={imageURL ?? item.insumo.urlImagem} />
                      <p>
                        Quantidade: {item?.insumoCompras[0]?.quantidadeTotal}Kg
                        <br />
                        Entrega prevista: semana {item?.rodadaEntregaPrevista.numero}
                        <br />
                        Custo: {item.preco}
                      </p>
                    </div>
                  )
                })
                }
              </MainRoundContainer>
            </RoundContainer>
          )
        })

        }

        {/* <RoundContainer>
          <H2RoundContainer className="totalsRound">
            TOTAL DE RODADAS
            <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
          </H2RoundContainer>
          <ParagraphRoundContainer>
            Compra de insumos
            <img src="./images/purchase_button.svg" alt="purchase_button" />
          </ParagraphRoundContainer>
          <MainRoundContainer>
            <div>
              <img src="./images/chicken_l.svg" alt="chicken_l" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/chicken_p.svg" alt="chicken_p" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/condiment.svg" alt="condiment" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/carry_bag.svg" alt="carry_bag" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/fries_pcp.svg" alt="fries_pcp" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/box.svg" alt="box" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/pig.svg" alt="pig" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
          </MainRoundContainer>
        </RoundContainer> */}
      </SizeContainer>
    </Container>
  );
};
export default WeeklyReportPurchase;
